import axios from 'axios';

export const BASE_URL = window.location.protocol + '//' + window.location.hostname + (window.location.port !== '' && process.env.NODE_ENV !== 'development' ? ':' + window.location.port : '') + '/api';

export const HTTP = axios.create({
    baseURL: BASE_URL,
    withCredentials: true
});


// WEBPACK FOOTER //
// ./src/http.js